export enum LeaveTimeType {
  ALL = 'all',
  OVERTIME = 'overtime',
  VACATION = 'vacation',
  SICK = 'sick',
}
